import styled from "@emotion/styled";

export const StyledSelectWithIcon = styled.div`
  .select-with-icon {
    .select__control {
      .select__value-container {
        .select-option-with-icon {
          background: #dff0ff;
        }
      }
    }
  }
`;
